import { Directive, TemplateRef, Inject } from "@angular/core";
import { LgPivotTableRowDefBase } from "./lg-pivot-table-row-def-base";

import { LgPivotTableBodyRegister, IBodyRegister, IRowSeparatorTemplate } from "../types";

@Directive({
    selector: "[lgPivotTableRowSeparatorDef]",
    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
    inputs: [
        "level: lgPivotTableRowSeparatorDefOnLevel",
        "visible: lgPivotTableRowSeparatorDefVisible",
        "height: lgPivotTableRowSeparatorDefHeight"
    ]
})
export class LgPivotTableRowSeparatorDefDirective
    extends LgPivotTableRowDefBase
    implements IRowSeparatorTemplate
{
    public constructor(
        @Inject(LgPivotTableBodyRegister) _body: IBodyRegister,
        _template: TemplateRef<any>
    ) {
        super(_body, _template);
    }

    protected _notifyMove(oldLevel: number | string): void {
        this._body.rowSeparatorTemplates.move(this, oldLevel);
    }

    protected _notifyChange(): void {
        this._body.rowSeparatorTemplates.change(this);
    }

    protected _notifyInit(): void {
        this._body.rowSeparatorTemplates.add(this);
    }

    protected _notifyDestroy(): void {
        this._body.rowSeparatorTemplates.remove(this);
    }
}
